import React from 'react'
import { Avatar, Box, Button, Dialog, DialogActions, IconButton, Typography, Slide } from '@mui/material'
import { Close, TaskAlt, HighlightOff } from '@mui/icons-material'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const ConfirmationDialog = ({ open, onClose, message, error, isProfileComplete }) => {

    const handleGoToEditProfile = () => {
        window.location.href = "/edit-profile"
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xs"
            fullWidth
            TransitionComponent={Transition}
            role="dialog"
            aria-hidden={!open}
        >
            <IconButton aria-label="close" onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                }}
            >
                <Close />
            </IconButton>
            <Box sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2 }}>
                <Avatar sx={{
                    bgcolor: message ? 'primary.main' : 'background.default',
                    color: message ? 'primary.contrastText' : 'grey.500',
                    width: 60,
                    height: 60
                }}>
                    {message ?
                        <TaskAlt fontSize='large' />
                        : <HighlightOff fontSize='large' />
                    }

                </Avatar>
                <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center' }}>
                    {message ? message : error}
                </Typography>
            </Box>

            <DialogActions sx={{ justifyContent: 'center', p: 3, pt: 0 }}>
                {isProfileComplete ? (
                    <Button
                        onClick={onClose}
                        color="primary"
                        autoFocus
                        disableElevation
                        variant='contained'
                        sx={{
                            textTransform: "none",
                            padding: '8px 48px',
                            fontSize: '1rem',
                        }}  >
                        {message ? "Ok" : "Close"}
                    </Button>
                ) : (
                    <Button
                        onClick={handleGoToEditProfile}
                        color="primary"
                        autoFocus
                        disableElevation
                        variant='contained'
                        sx={{
                            textTransform: "none",
                            padding: '8px 48px',
                            fontSize: '1rem',
                        }}  >
                        Complete Profile
                    </Button>
                )}

            </DialogActions>


        </Dialog>
    )
}

export default ConfirmationDialog
